export default __webpack_public_path__ + "static/logo-47302a10f0d3fe621df06430007971d8.png";